import {
  Box,
  Grid,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import { Enumerations } from "../../config/Enumerations";
import moment from "moment";
import { useEffect } from "react";

export default function ReviewDetails({ appReview, appEntry }) {
  const theme = useTheme();

  return (
    <Grid item xs={12} className="entry-details-container">
      <div className="entry-details-title">
        <Typography
          variant="h6"
          style={{ color: theme.palette.secondary.main }}
        >
          Детали за барањето
        </Typography>
      </div>
      <Table size="small" sx={{ marginBottom: 2 }}>
        <TableRow>
          <TableCell>Тип на барање</TableCell>
          <TableCell>
            {Enumerations.AppEntryTypeDisplay[appReview?.appEntry?.type]}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Датум на поднесување до институција</TableCell>
          <TableCell>
            {appReview?.createdAt
              ? moment(appReview?.createdAt).format("DD.MM.YYYY HH:mm")
              : "/"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Датум на одлука (испратено до МТ)</TableCell>
          <TableCell>
            {appReview?.dateOfDecision
              ? moment(appReview?.dateOfDecision).format("DD.MM.YYYY HH:mm")
              : "/"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Архивски број</TableCell>
          <TableCell>{appReview?.instArchiveNumber || "/"}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Проектантско биро</TableCell>
          <TableCell>
            {appReview?.appEntry?.appEntryData?.projectBureauName || "/"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Технички број</TableCell>
          <TableCell>
            {appReview?.appEntry?.appEntryData?.projectTechnicalNumber || "/"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Подносител до Министерство за транспорт</TableCell>
          <TableCell>
            {appReview?.appEntry?.appEntryData?.applicantName},{" "}
            {appReview?.appEntry?.appEntryData?.applicantEmail},{" "}
            {appReview?.appEntry?.appEntryData?.applicantPhone}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Проект</TableCell>
          <TableCell>
            {appReview?.appEntry?.appEntryData?.projectTitle || "/"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Локација</TableCell>
          <TableCell>
            {appReview?.appEntry?.appEntryData?.locationDescription || "/"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Предмет</TableCell>
          <TableCell>
            {appReview?.appEntry?.appEntryData?.subject || "/"}
          </TableCell>
        </TableRow>
      </Table>
    </Grid>
  );
}
